export default __webpack_public_path__ + "static/media/pull_payment_top_bg_mobile.0d3054f3.png";